import useTranslate from '@root/core/hooks/useTranslate';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Tabss from '../components/Tabss';
import SignUpDate from '../components/SignUpDate';
import buskforwardingdetail from '../services/buskforwardingdetail';
import { Table, Tabs } from 'antd';
import FormSellerInfo from '../components/FormSellerInfo';
import { useHistory } from 'react-router-dom';

const ForwardingDetail = () => {
  const [t] = useTranslate();
  const { id } = useParams<{ id: string }>();
  console.log(id, 'id');
  const [tabChange, setTabChange] = useState('1');
  const history = useHistory();
  const checkTabState = (tabChange: string) => {
    switch (tabChange) {
      case '1':
        return '업체 정보';
      case '2':
        return '셀러 대화 목록';
    }
  };
  const breadcrumbList = [
    {
      tittle: '포워딩 업체 관리',
      url: '/admin/busk/forwarding'
    },
    {
      tittle: checkTabState(tabChange) as string,
      url: ''
    }
  ];

  const handleTabChange = (key: string) => {
    setTabChange(key);
  };

  const [formData, setFormData] = useState();

  const getWarehouseDetail = async (id: string) => {
    const buskWarehouseDetail = await buskforwardingdetail.getForwardingDetail(
      id
    );
    setFormData(buskWarehouseDetail.data);
    console.log(buskWarehouseDetail.data);
  };

  const [page, setPage] = useState(1);
  const [postList, setPostList] = useState([]);

  const getPostList = async () => {
    const buskPostList = await buskforwardingdetail.getPostList(page, id);
    setPostList(buskPostList.data);
  };
  console.log(postList, 'postList');
  const onUpdate = async (data: any) => {
    const updated = await buskforwardingdetail.updateForwardingDetail(
      Number(id),
      data
    );
    setFormData(updated.data);
  };

  useEffect(() => {
    getWarehouseDetail(id);
    getPostList();
  }, []);

  useEffect(() => {
    getPostList();
  }, [page]);

  console.log(postList);

  const columns = [
    {
      title: 'No',
      dataIndex: 'id'
    },
    {
      title: '셀러 ID',
      dataIndex: 'seller',
      render: (seller: any) => seller?.id || '-'
    },
    {
      title: '셀러명',
      dataIndex: 'seller',
      render: (seller: any) => seller?.companyName || '-'
    },
    {
      title: '견적요청서 선택 유무',
      dataIndex: 'hasQuotation',
      render: (value: boolean) => (value ? 'Yes' : 'No')
    },
    {
      title: '대화 상태',
      dataIndex: 'cancelStatusText'
    },
    {
      title: '진행 상태',
      dataIndex: 'status'
    },
    {
      title: '첫 대화 일시',
      dataIndex: 'startedAt'
    },
    {
      title: '마지막 대화 일시',
      dataIndex: 'lastMessage',
      render: (lastMessage: any) => lastMessage?.created_at || '-'
    }
  ];

  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container busk-tabs">
        <SignUpDate formData={formData} />
        <Tabs defaultActiveKey="1" onChange={(e) => handleTabChange(e)}>
          <Tabs.TabPane tab="업체 정보" key="1">
            <FormSellerInfo onUpdate={onUpdate} formData={formData as any} />
          </Tabs.TabPane>

          <Tabs.TabPane tab="셀러 대화 목록" key="2">
            <Table
              columns={columns}
              dataSource={postList}
              onRow={(record) => {
                return {
                  onClick: () =>
                    history.push(`/admin/busk/forwarding/${id}/${record.id}`)
                };
              }}
            />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default ForwardingDetail;
